import { useDispatch, useSelector } from "react-redux";
import { ReducersTypes } from "../../redux/reducers/Models";
import { validateCPF, validateCNPJ } from "@/utils/functions";
import ForgotPasswordView from "./view";
import { useNavigate } from "react-router-dom";
import { setCustomer } from "@/redux/ducks/customer";

export default function ForgotPassword() {
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);

  const goBack = () => navigate(-1);

  const handleDocumentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const numericValue = e.target.value.replace(/\D/g, "");

    let formattedValue = numericValue;
    if (numericValue.length === 11) {
      const cpfWithMask = numericValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      if (validateCPF(cpfWithMask)) formattedValue = cpfWithMask;
    } else if (numericValue.length === 14) {
      const cnpjWithMask = numericValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
      if (validateCNPJ(cnpjWithMask)) formattedValue = cnpjWithMask;
    }

    dispatch(setCustomer({
      forgot: {
        ...customer?.forgot,
        document: formattedValue,
      }
    }));
  };

  const handleDocumentPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const cleanValue = e.clipboardData.getData("text").replace(/\D/g, "");

    let formattedValue = cleanValue;
    if (cleanValue.length === 11) {
      const cpfWithMask = cleanValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      if (validateCPF(cpfWithMask)) formattedValue = cpfWithMask;
    } else if (cleanValue.length === 14) {
      const cnpjWithMask = cleanValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
      if (validateCNPJ(cnpjWithMask)) formattedValue = cnpjWithMask;
    }

    dispatch(setCustomer({
      forgot: {
        ...customer?.forgot,
        document: formattedValue,
      }
    }));
  };

  const getIsDisabled = () => {
    const doc = customer?.forgot?.document ?? "";
    return !validateCPF(doc) && !validateCNPJ(doc);
  }

  const goToPin = () => {
    if (getIsDisabled()) return;
    
    navigate('/forgot/pin');
  }
  
  return <ForgotPasswordView 
    goBack={goBack}
    customer={customer}
    onChange={handleDocumentChange}
    onPaste={handleDocumentPaste}
    goToPin={goToPin}
    isDisabled={getIsDisabled()}
  />;
}
